import { Toast } from '@easyvaas/js-components';
import { useRecoilCallback } from 'recoil';
import { materialItemSelector } from '../store/selector';

export const useCheckMaterialEnough = () => {
  const check = useRecoilCallback(
    ({ snapshot }) => (material: ImageV3API.Material, required: number) => {
      if (material.specialExtend?.polishToolId) {
        //支持打磨的宝石，需要合并计算
        const item = snapshot.getLoadable(
          materialItemSelector(material.specialExtend.polishToolId)
        );
        if (item.state !== 'hasValue') return false;
        const balance = (item.contents?.number || 0) + material.number;
        if (balance < required) {
          Toast(`${material.title}不足`);
          return false;
        }
      } else if (material.number < required) {
        Toast(`${material.title}不足`);
        return false;
      }
      return true;
    },
    []
  );
  return check;
};
